import { render, staticRenderFns } from "./gc-popup-bank-transfer.vue?vue&type=template&id=72ed8da9&"
import script from "./gc-popup-bank-transfer.vue?vue&type=script&lang=js&"
export * from "./gc-popup-bank-transfer.vue?vue&type=script&lang=js&"
import style0 from "./gc-popup-bank-transfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports